import { Box, HStack, Icon } from '@chakra-ui/react';
import {
  TwitterIcon,
  LinkedInIcon,
  GitHubIcon,
  DiscordIcon,
  FacebookIcon
} from '@components';
import Link from 'next/link';
import { URLS } from '@lib';

const { twitter, linkedin, facebook, discord, github } = URLS;

export function Socials(): JSX.Element {
  return (
    <HStack
      gap="24px"
      display={'flex'}
      w="auto"
      justifyContent={{ base: 'space-between', md: 'normal' }}
      zIndex={10}
    >
      <Link legacyBehavior href={twitter} passHref>
        <Box as="a">
          <Icon as={TwitterIcon} h="24px" w="24px" color="#949EB2"></Icon>
        </Box>
      </Link>
      <Link legacyBehavior href={linkedin} passHref>
        <Box as="a">
          <Icon as={LinkedInIcon} h="24px" w="24px" color="#949EB2"></Icon>
        </Box>
      </Link>
      <Link legacyBehavior href={github} passHref>
        <Box as="a">
          <Icon as={GitHubIcon} h="24px" w="24px" color="#949EB2"></Icon>
        </Box>
      </Link>
      <Link legacyBehavior href={discord} passHref>
        <Box as="a">
          <Icon as={DiscordIcon} h="24px" w="24px" color="#949EB2"></Icon>
        </Box>
      </Link>

      <Link legacyBehavior href={facebook} passHref>
        <Box as="a">
          <Icon as={FacebookIcon} h="24px" w="24px" color="#949EB2"></Icon>
        </Box>
      </Link>
    </HStack>
  );
}
